import { Record } from '@common/data-models/records/record';
import { Subject, Subscription } from 'rxjs';

// TODO REWORK THIS SHIT
export class NewlyCreatedRecords {
    public changesSub: Subscription = new Subscription();
    public resetCostSubject = new Subject<void>();
    public items: Array<StorytellingRecord> = [];
    public itemsGuids: { [id: string]: boolean } = {};

    public parentCostProps = [];
    private childCostProps = [];
    public costView: boolean = true;

    private _cost: number = -1;
    public get cost(): number {
        // if (this._cost > -1) return this._cost;

        // if (this.items.length > 0 && ((this.parentCostProps && this.parentCostProps.length > 0) || (this.childCostProps && this.childCostProps.length > 0))) {
        //     this._cost = 0;
        //     this.items.forEach(item => {
        //         let props: Array<FieldDef> = [];
        //         if (item.isCollection) {
        //             props = this.parentCostProps;
        //             const children = (<StorytellingCollectionRecord>item).children;
        //             for (const child of children) {
        //                 for (const prop of this.childCostProps) {
        //                     const costProp = child.getAs<Table>(prop.ID);
        //                     if (costProp) {
        //                         costProp.calculateCost(Record.globalTablesService.getListColumnsForSpecialField(prop.ID));
        //                         this._cost += costProp.totalCost;
        //                     }
        //                 }
        //             }
        //         }
        //         if (item.isCollection) props = this.parentCostProps;
        //         for (const prop of props) {
        //             const costProp = item.getAs<Table>(prop.ID);
        //             if (costProp) {
        //                 costProp.calculateCost(Record.globalTablesService.getListColumnsForSpecialField(prop.ID));
        //                 this._cost += costProp.totalCost;
        //             }
        //         }
        //     });
        // }
        // if (this.items.length === 0 && ((this.parentCostProps && this.parentCostProps.length) > 0 || (this.childCostProps && this.childCostProps.length > 0))) this._cost = 0;
        return this._cost;
    }

    public set cost(v: number) {
        this._cost = v;
    }

    public addRecord(_rec: StorytellingRecord, _idx?: number) {
        // if (rec) {
        //     if (!this.itemsGuids) {
        //         this.itemsGuids = {};
        //     }
        //     if (!this.items) {
        //         this.items = [];
        //     }
        //     if (!this.itemsGuids[rec.guid]) {
        //         if (!idx) {
        //             this.items.push(rec);
        //             this.itemsGuids[rec.guid] = true;
        //         } else {
        //             this.items.splice(idx + 1, 0, rec);
        //             this.itemsGuids[rec.guid] = true;
        //         }
        //     }
        //     this.registerTiles();
        // }
    }

    public dispose() {
        this.items = [];
        this.itemsGuids = {};
        this.unRegisterTiles();
    }

    public remove(_rec: StorytellingRecord) {
        // if (this.itemsGuids[rec.guid]) {
        //     delete this.itemsGuids[rec.guid];
        // }
        // for (let i = 0; i < this.items.length; i++) {
        //     if (this.items[i].guid === rec.guid) {
        //         this.items.splice(i, 1);
        //         break;
        //     }
        // }
        // this.registerTiles();
    }

    public registerTiles() {
        // if (this.changesSub) this.changesSub.unsubscribe();
        // this.changesSub = new Subscription();
        // this.items.forEach(item => {
        //     const tmpSub = item.changeObserver.subscribe(() => {
        //         this.registerTiles();
        //         this.resetCostSubject.next();
        //     });
        //     if (item.isCollection) {
        //         const children = (<StorytellingCollectionRecord>item).getChildren();
        //         for (const child of children) {
        //             const assignmentSub = child.changeObserver.subscribe(() => {
        //                 this.resetCostSubject.next();
        //             });
        //             this.changesSub.add(assignmentSub);
        //         }
        //     }
        //     this.changesSub.add(tmpSub);
        // });
        // this.resetCostSubject.next();
    }

    public unRegisterTiles() {
        this.resetCostSubject.next();
    }

    constructor() {
        if (Record.globalTablesService) {
            this.parentCostProps = Record.globalTablesService.getSpecialPropertiesFor('Topic').filter(prop => prop.Validation.toUpperCase() === 'COST');
            this.childCostProps = Record.globalTablesService.getSpecialPropertiesFor('Assignment').filter(prop => prop.Validation.toUpperCase() === 'COST');
            if ((this.parentCostProps && this.parentCostProps.length > 0) || (this.childCostProps && this.childCostProps.length > 0)) {
                this.registerTiles();
                this.resetCostSubject.asObservable().subscribe(() => {
                    this.cost = -1;
                });
                this.costView = Record.globalTablesService.securityPrivileges[Record.nomWebServicesJson.PSTGroup].cost.read;
            }
        }
    }
}
